import {connect} from "react-redux";
import Journey from "./Journey";
import {bindActionCreators} from "redux";
import {save, getJourney} from "../../service/Journey/action";
import {documentUploadUrlPublic} from "../../service/fileUpload/action";

const mapStateToProps = (state) => ({
    journeyDetails: state.Journey.journeyDetails,
    getUserJourney: state.Journey.getUserJourney,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            save,
            documentUploadUrlPublic,
            getJourney
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Journey);
